import axios from 'axios';
import { getAppConfig } from '@client/core/config/get-app-config';
import { AppClientHeader, AppClientPlatform } from '@client/core/http/build-client-header';

const { csrfToken, build } = getAppConfig();

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

const clientHeader: AppClientHeader = {
  // Distinguish as legacy client requests instead of modern web app requests
  platform: AppClientPlatform.WebLegacy,
  version: build.sha,
  timestamp: build.timestamp,
};
axios.defaults.headers.common['X-FF-CLIENT'] = JSON.stringify(clientHeader);

/**
 * This HTTP client is used by legacy components.
 */
export default axios;
